import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyConfirmVehiclePage = {
  alert: {
    submitFailedError: 'apply-confirm-vehicle-page.alert.submit-failed-error',
    vehicleTrimsError: 'apply-confirm-vehicle-page.alert.vehicle-trims-error',
  },
  footer: {
    root: 'apply-confirm-vehicle-page.footer.root',
  },
  form: {
    h1: 'apply-confirm-vehicle-page.form.h1',
    h2: 'apply-confirm-vehicle-page.form.h2',
    mileageInput: 'apply-confirm-vehicle-page.form.mileage-input',
    mileageInputError: 'apply-confirm-vehicle-page.form.mileage-input-error',
    payoffAmountInput: 'apply-confirm-vehicle-page.form.payoff-amount-input',
    payoffAmountInputError:
      'apply-confirm-vehicle-page.form.payoff-amount-input-error',
    purchasePriceInput: 'apply-confirm-vehicle-page.form.purchase-price-input',
    purchasePriceInputError:
      'apply-confirm-vehicle-page.form.purchase-price-input-error',
    root: 'apply-confirm-vehicle-page.form.root',
    submitButton: 'apply-confirm-vehicle-page.form.submit-button',
    trimSelect: 'apply-confirm-vehicle-page.form.trim-select',
    trimSelectError: 'apply-confirm-vehicle-page.form.trim-select-error',
  },
  main: {
    placeholderVehicleImage:
      'apply-confirm-vehicle-page.main.placeholder-vehicle-image',
    root: 'apply-confirm-vehicle-page.main.root',
    selectedVehicleImage:
      'apply-confirm-vehicle-page.main.selected-vehicle-image',
  },
} as const satisfies PageLocatorMap;
